<template>
    <div class="padding-content white-content mb-4">
        <div class="d-flex justify-content-between align-items-center">
            <div class="h2 mb-3"> <span>{{ $t('general.abono', { abono: teatro.texto_abono.toUpperCase() }) }} {{ index }}</span></div>
            <button v-if="index > 1" id="eliminar" class="button effect-button" :disabled="desactivar" @click="eliminarAbono()"><span>{{ $t('nuevo_abono.delete_abono', { abono: teatro.texto_abono }) }}</span></button>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :label="$t('formularios.nombre')" :name="'nombre' + index" rules="required" v-model="abono.nombre" :disabled="desactivar"/>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :label="$t('formularios.apellido1')" :name="'apellido1-' + index" rules="required" v-model="abono.apellido1" :disabled="desactivar"/>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :label="$t('formularios.apellido2')" :name="'apellido2-' + index" rules="required" v-model="abono.apellido2" :disabled="desactivar"/>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput infoText="A modo informativo queremos aconsejarle que sea cuál sea el formato en el que introduzca el DNI lo recuerde para posibles futuros procesos" :disabled="desactivar" :label="$t('formularios.dni')" :name="'dni' + index" rules="required" v-model="abono.dni" />
            </div>
            <div class="col-12 col-md-6 col-lg-4 mb-2">
                <div class="form-group">
                    <label>{{ $t('formularios.telefono') }}</label>
                    <PhoneInput
                        :key="error_telefono"
                        :name="'telefono' + index" 
                        :phone="abono.telefono ?? null" 
                        :desactivar="desactivar" 
                        :required="true"
                        :error_telefono="error_telefono"
                        @setNumber="(number) => abono.telefono = number"
                        @validNumber="(valid) => abono.telefono_valido = valid"
                    />
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :disabled="desactivar" :label="$t('formularios.domicilio')" :name="'domicilio' + index" rules="required" v-model="abono.domicilio" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :disabled="desactivar" :label="$t('formularios.escalera')" :name="'escalera' + index" rules="required" v-model="abono.escalera" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :disabled="desactivar" :label="$t('formularios.n_calle')" :name="'n_calle' + index" rules="required" v-model="abono.n_calle" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :disabled="desactivar" :label="$t('formularios.piso')" :name="'piso' + index" rules="required" v-model="abono.piso" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :disabled="desactivar" :label="$t('formularios.cp')" :name="'cp' + index" rules="required" v-model="abono.cp" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Paises :desactivar="desactivar" :pais="pais" :errors="errors" @rellenarPais="rellenarPais" v-on:selected="opt => { pais = opt; abono.pais = opt.nombre; }"/>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Provincias :desactivar="desactivar" :errors="errors" :pais="pais.id" :provincia="provincia" v-on:selected="opt => { provincia = opt; abono.provincia = opt.nombre; }"/>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Locations :desactivar="desactivar" :provincia="provincia" :errors="errors" v-on:selected="opt => { abono.localidad = opt.nombre; }"/>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :disabled="desactivar" :label="$t('formularios.iban')" :name="'iban' + index" rules="required" v-model="abono.iban" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <label>{{ $t('formularios.genero') }}</label>
                    <ValidationProvider :name="'genero' + index" rules="required" v-slot="{ errors }">
                        <multiselect
                            :id="'genero' + index"
                            :disabled="desactivar"
                            v-model="abono.genero"
                            :placeholder="$t('formularios.genero')"
                            label="name"
                            track-by="id"
                            :options="generos"
                            class="custom-multiselect"
                            @select="(option, id) => abono.genero_id = option.id"
                        />
                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <label for="fecha_nacimiento">{{ $t('formularios.nacimiento') }}</label>
                    <ValidationProvider :name="'fecha_nacimiento' + index" :rules="{ required: true, valid_date: 'noFuture' }" v-slot="{ errors }">
                        <input type="date" v-model="abono.fecha_nacimiento" id="fecha_nacimiento" name="fecha_nacimiento" min="1900-01-01"/>
                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput :disabled="desactivar" :label="$t('formularios.email')" :name="'email' + index" rules="required" v-model="abono.email" />
            </div>
            <div class="col-12" v-if="solicitarDocumentacion">
                <label>{{ textoDocumentacion || 'Adjuntá la documentación requerida' }}</label>
                <Dropzone
                    v-if="url"
                    :url="url"
                    :maxFiles="5"
                    :maxFilesize="maxFilesize"
                    @success="imagenSubida"
                    acceptedFiles="image/jpeg,image/png,image/gif,image/bmp,image/tiff,application/pdf,.pdf"
                />
                <h3 style="font-size: 19px;">Peso máximo: {{ maxFilesize }} MB</h3>
            </div>
        </div>
    </div>
</template>

<script>
    import Provincias from '@/components/common/forms/Provincias.vue';
    import Locations from "@/components/common/forms/Locations";
    import Paises from "@/components/common/forms/Paises";
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import Dropzone from '@/components/common/Dropzone';

    export default {
        props: ['abono', 'index', 'desactivar', 'validator', 'error_telefono', 'solicitarDocumentacion', 'textoDocumentacion'],
        data() {
            return {
                errors: [],
                provincia: null,
                pais: { id: 0 },
                url: null,
                maxFilesize: 20
            }
        },
        methods: {
            rellenarPais(pais) {
                if (pais && pais.nombre) {
                    this.pais = pais;
                    this.abono.pais = pais.nombre;
                }
            },
            eliminarAbono() {
                this.$emit('eliminarAbono', this.index);
            },
            setDropZone() {
                this.url = this.config.API_BASE + '/f/upload/documento?tid=' + this.configuracion.hash_teatro;
            },
            imagenSubida(file, response) {
                if (response && response.id) {
                    if (!this.abono.documentaciones) {
                        this.$set(this.abono, 'documentaciones', []);
                    }
                    this.abono.documentaciones.push(response.id);
                }
            }
        },
        mounted() {
            this.$emit('errorDatos', false);
            if (this.solicitarDocumentacion) {
                this.setDropZone();
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            generos() {
                return this.$store.getters.getGeneros;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        created() {
            // Initialize pais from abonado data (string name like "Andorra")
            if (this.abono.pais) {
                this.pais = { nombre: this.abono.pais };
            }

            // Initialize provincia: prefer abonado data.
            // Only fall back to teatro default for NEW abonos (not renewals).
            if (this.abono.provincia) {
                this.provincia = this.abono.provincia;
            } else if (!this.abono.n_abonado_antiguo && this.teatro.provincia) {
                this.provincia = this.teatro.provincia;
            }
        },
        components: {
            Locations,
            Provincias,
            Paises,
            PhoneInput,
            Dropzone
        }
    }
</script>

<style scoped>
    #paso3 .multiselect__tags {
        background-color: #f1f1f1 !important;
        border-color: #ccc;
    }

    .dropzone-preview {
        position: relative;
        z-index: 1;
    }

    .price-large {
        font-size: 40px !important;  
    }
    .lightgray-content .checkbox-container input[type="checkbox"] + label:before, .lightgray-content .checkbox-container input[type="radio"] + label:before {
        background-color: #ededed;
    }
</style>
